"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AuthState = require("../../AuthState");

var _AuthState2 = _interopRequireDefault(_AuthState);

var _callEach = require("../../utilities/callEach");

var _callEach2 = _interopRequireDefault(_callEach);

var _estore = require("../api/estore");

var _jsCookie = require("js-cookie");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultState = {
  authState: _AuthState2.default.UNKNOWN,
  itemsInCart: 0,
  userName: null,
  userFirstName: null
};

var ECommLoginService = function () {
  function ECommLoginService(config) {
    _classCallCheck(this, ECommLoginService);

    this.onChangeCallbacks = [];
    this.state = _extends({}, defaultState);

    this.config = config;
  }

  /**
   * Initialize the object. Make calls to ecomm, and update the state based on responses.
   */


  _createClass(ECommLoginService, [{
    key: "activate",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fetchDetails();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function activate() {
        return _ref.apply(this, arguments);
      }

      return activate;
    }()

    /**
     * Fetch details. Send a request to eStore, to get cart state.
     */

  }, {
    key: "fetchDetails",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var userNames, cartDetails;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                userNames = this.config.nameCookies.map(_jsCookie2.default.get).filter(function (v) {
                  return typeof v !== "undefined";
                }).map(function (v) {
                  return v.trim();
                }).filter(function (v) {
                  return v.length > 0;
                });
                _context2.next = 4;
                return (0, _estore.cart)(this.config.estoreLocation);

              case 4:
                cartDetails = _context2.sent;


                userNames.push(cartDetails.userName);

                this.state.userName = userNames[0];
                this.state.userFirstName = cartDetails.firstName;

                this.state.authState = this.state.userName === "Anonymous" ? _AuthState2.default.LOGGED_OUT : _AuthState2.default.LOGGED_IN;
                this.state.itemsInCart = cartDetails.itemsInCart;
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);

                this.state = _extends({}, defaultState, {
                  authState: _AuthState2.default.LOGGED_OUT
                });

                throw _context2.t0;

              case 16:
                _context2.prev = 16;

                this.privateTriggerChange();
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 12, 16, 19]]);
      }));

      function fetchDetails() {
        return _ref2.apply(this, arguments);
      }

      return fetchDetails;
    }()

    /**
     * Redirect to login of tax site.
     */

  }, {
    key: "login",
    value: function login() {
      if (window) {
        window.location.assign(this.loginUrl);
      }
    }

    /**
     * Logout. Redirect to logout of Hybris.
     */

  }, {
    key: "logout",
    value: function logout() {
      if (window) {
        window.location.assign(this.logoutUrl);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(cb) {
      this.onChangeCallbacks.push(cb);
    }
  }, {
    key: "offChange",
    value: function offChange(cb) {
      if (this.onChangeCallbacks.includes(cb)) {
        this.onChangeCallbacks.splice(this.onChangeCallbacks.indexOf(cb), 1);

        return true;
      }

      return false;
    }
  }, {
    key: "privateTriggerChange",
    value: function privateTriggerChange() {
      (0, _callEach2.default)(this.onChangeCallbacks, this);
    }
  }, {
    key: "accountOverviewUrl",
    get: function get() {
      return this.config.accountOverviewUrl;
    }
  }, {
    key: "authState",
    get: function get() {
      return this.state.authState;
    }
  }, {
    key: "cartUrl",
    get: function get() {
      return this.config.cartUrl;
    }
  }, {
    key: "itemsInCart",
    get: function get() {
      return this.state.itemsInCart;
    }
  }, {
    key: "logoutUrl",
    get: function get() {
      return this.config.logoutUrl;
    }
  }, {
    key: "loginUrl",
    get: function get() {
      return this.config.loginUrl;
    }
  }, {
    key: "userName",
    get: function get() {
      return this.state.userName;
    }
  }, {
    key: "userFirstName",
    get: function get() {
      return this.state.userFirstName;
    }
  }]);

  return ECommLoginService;
}();

exports.default = ECommLoginService;